const { client } = require('../../MbaasClient')

export const funcGetOneDefault = async (resource, params) => {
  const { data } = await client.getTable(resource).lookup(params.id)
  return { data: data }
}
